export default "__VITE_ASSET__DskQn8eO__"